module.exports = __webpack_public_path__ + "media/images/flags/16/Nepal-72ccaf14077ce25b5dc95e0f8a4aa1ee.png";